// This file should be pure data.

export const CONSTANTS = {
  "AI_CONFIG": {
    "DRAW_AGAIN_PROBABILITY": [
      1,
      0.5,
      0.1
    ]
  },
  "AUDIO": {
    "DEFAULT_MUSIC_VOLUME": 0.5,
    "DEFAULT_SFX_VOLUME": 0.7,
    "SOUND_EFFECTS": {
      "bust": "bust_sound",
      "buttonClick": "button_click",
      "cardDraw": "card_draw",
      "cardPlace": "card_place",
      "gameOver": "game_over",
      "steal": "steal_sound",
      "turnEnd": "turn_end"
    }
  },
  "BACKGROUND_CARDS": {
    "BLUR_RANGE": [
      0,
      2
    ],
    "COUNT": 20,
    "OPACITY_RANGE": [
      0.1,
      0.2
    ],
    "ROTATION_RANGE": [
      -45,
      45
    ],
    "SCALE_RANGE": [
      0.8,
      1.4
    ]
  },
  "BUST_THRESHOLD": 4,
  "CARD_DISTRIBUTION": [
    {
      "color": "lightblue",
      "count": 13,
      "imageAlias": "face1",
      "number": 1
    },
    {
      "color": "purple",
      "count": 13,
      "imageAlias": "face2",
      "number": 2
    },
    {
      "color": "orange",
      "count": 13,
      "imageAlias": "face3",
      "number": 3
    },
    {
      "color": "darkred",
      "count": 13,
      "imageAlias": "face4",
      "number": 4
    },
    {
      "color": "lightgreen",
      "count": 13,
      "imageAlias": "face5",
      "number": 5
    },
    {
      "color": "red",
      "count": 9,
      "imageAlias": "face6",
      "number": 6
    },
    {
      "color": "yellow",
      "count": 9,
      "imageAlias": "face7",
      "number": 7
    },
    {
      "color": "darkblue",
      "count": 9,
      "imageAlias": "face8",
      "number": 8
    },
    {
      "color": "green",
      "count": 9,
      "imageAlias": "face9",
      "number": 9
    },
    {
      "color": "pink",
      "count": 9,
      "imageAlias": "face10",
      "number": 10
    }
  ],
  "COLOR_PALETTES": {
    "green": {
      "key": "green",
      "name": "Emerald Forest",
      "primary": "#064e3b",
      "primaryLight": "#166534",
      "primaryDark": "#022c22",
      "secondary": "#22c55e",
      "accent": "#facc15",
      "background": "#022c22",
      "backgroundLight": "#166534",
      "text": "#ffffff",
      "button": "#facc15",
      "buttonText": "#064e3b"
    },
    "blue": {
      "key": "blue",
      "name": "Oceanic Blue",
      "primary": "#1e3a8a",
      "primaryLight": "#2563eb",
      "primaryDark": "#0a2540",
      "secondary": "#38bdf8",
      "accent": "#fbbf24",
      "background": "#0a2540",
      "backgroundLight": "#2563eb",
      "text": "#ffffff",
      "button": "#38bdf8",
      "buttonText": "#1e3a8a"
    },
    "purple": {
      "key": "purple",
      "name": "Royal Purple",
      "primary": "#6d28d9",
      "primaryLight": "#a78bfa",
      "primaryDark": "#3b0764",
      "secondary": "#f472b6",
      "accent": "#facc15",
      "background": "#3b0764",
      "backgroundLight": "#a78bfa",
      "text": "#ffffff",
      "button": "#f472b6",
      "buttonText": "#6d28d9"
    },
    "orange": {
      "key": "orange",
      "name": "Sunset Orange",
      "primary": "#ea580c",
      "primaryLight": "#fdba74",
      "primaryDark": "#7c2d12",
      "secondary": "#fbbf24",
      "accent": "#22d3ee",
      "background": "#7c2d12",
      "backgroundLight": "#fdba74",
      "text": "#ffffff",
      "button": "#fbbf24",
      "buttonText": "#ea580c"
    }
  },
  "DEFAULT_COLOR_PALETTE": "green",
  "CONFETTI_DURATION": 9,
  "CPU_PLAYER_NAMES": {
    "bottom": "You",
    "left": "Player 2",
    "right": "Player 4",
    "top": "Player 3"
  },
  "SPEED_LEVELS": {
    "1": {
      "NAME": "x1",
      "DRAW_DURATION": 1000,
      "BUST_ANIMATION_DURATION": 4,
      "BUST_CLEANUP_DELAY": 500,
      "STEAL_MESSAGE_DURATION": 1500,
      "AI_THINKING_TIME_MS": 1500,
      "ANIMATION_DELAY": 70
    },
    "2": {
      "NAME": "x2",
      "DRAW_DURATION": 500,
      "BUST_ANIMATION_DURATION": 2,
      "BUST_CLEANUP_DELAY": 250,
      "STEAL_MESSAGE_DURATION": 750,
      "AI_THINKING_TIME_MS": 750,
      "ANIMATION_DELAY": 60
    },
    "4": {
      "NAME": "x4",
      "DRAW_DURATION": 100,
      "BUST_ANIMATION_DURATION": 0.4,
      "BUST_CLEANUP_DELAY": 100,
      "STEAL_MESSAGE_DURATION": 200,
      "AI_THINKING_TIME_MS": 100,
      "ANIMATION_DELAY": 50
    }
  },
  "GAME_FOOTER": "© 2025 Alex's Pelusas Card Game",
  "GAME_SUBTITLE": "A Card Game of Risk and Steal",
  "GAME_TITLE": "Pelusas",
  "INSTRUCTIONS": {
    "STEPS": [
      {
        "cardExample": {
          "stacks": [
            [
              {
                "color": "orange",
                "imageAlias": "face3",
                "number": 3
              },
              {
                "color": "orange",
                "imageAlias": "face3",
                "number": 3
              }
            ],
            [
              {
                "color": "yellow",
                "imageAlias": "face7",
                "number": 7
              },
              {
                "color": "yellow",
                "imageAlias": "face7",
                "number": 7
              },
              {
                "color": "yellow",
                "imageAlias": "face7",
                "number": 7
              }
            ]
          ],
          "totalPoints": 27
        },
        "content": [
          "The goal is to score the most points by collecting cards and avoiding busts.",
          "Points are scored when you complete your turn by choosing to end it, and all your card stacks are added to your score.",
          "Balance risk and reward - the more cards you collect, the higher your score, but also the higher your risk of busting!"
        ],
        "example": "If you have stacks of [3,3] and [7,7,7], you would score 3+3+7+7+7 = 27 points when you end your turn.",
        "title": "Game Objective"
      },
      {
        "cardExample": {
          "after": [
            [
              {
                "color": "lightgreen",
                "imageAlias": "face5",
                "number": 5
              },
              {
                "color": "lightgreen",
                "imageAlias": "face5",
                "number": 5
              },
              {
                "color": "lightgreen",
                "imageAlias": "face5",
                "number": 5
              }
            ]
          ],
          "before": [
            [
              {
                "color": "lightgreen",
                "imageAlias": "face5",
                "number": 5
              },
              {
                "color": "lightgreen",
                "imageAlias": "face5",
                "number": 5
              }
            ]
          ],
          "drawnCard": {
            "color": "lightgreen",
            "imageAlias": "face5",
            "number": 5
          }
        },
        "content": [
          "On your turn, click 'Draw Card' to draw from the deck.",
          "The card you draw will be placed in a stack with other cards of the same number.",
          "If you don't have any cards of that number, a new stack is created.",
          "Each card's color represents its number - learn the colors to play faster!"
        ],
        "example": "If you draw a 5 and already have a stack of [5,5], the new card joins that stack to make [5,5,5].",
        "title": "Drawing Cards"
      },
      {
        "cardExample": {
          "afterSteal": [
            [
              {
                "color": "darkred",
                "imageAlias": "face4",
                "number": 4
              },
              {
                "color": "darkred",
                "imageAlias": "face4",
                "number": 4
              },
              {
                "color": "darkred",
                "imageAlias": "face4",
                "number": 4
              },
              {
                "color": "darkred",
                "imageAlias": "face4",
                "number": 4
              }
            ]
          ],
          "drawnCard": {
            "color": "darkred",
            "imageAlias": "face4",
            "number": 4
          },
          "stealableStacks": [
            [
              {
                "color": "darkred",
                "imageAlias": "face4",
                "number": 4
              },
              {
                "color": "darkred",
                "imageAlias": "face4",
                "number": 4
              }
            ],
            [
              {
                "color": "darkred",
                "imageAlias": "face4",
                "number": 4
              }
            ]
          ],
          "yourStack": [
            [
              {
                "color": "darkred",
                "imageAlias": "face4",
                "number": 4
              }
            ]
          ]
        },
        "content": [
          "After drawing a card, if other players have stacks with the same number, you can steal them!",
          "Click the 'Steal' button when it appears to take all matching stacks from other players.",
          "Stolen stacks merge with your existing stacks of the same number.",
          "This is a powerful way to build large stacks quickly - but be careful not to bust!"
        ],
        "example": "You draw a 4. Player 2 has [4,4] and Player 3 has [4]. You can steal both stacks and merge them with yours.",
        "title": "Stealing Cards"
      },
      {
        "cardExample": {
          "after": [],
          "before": [
            [
              {
                "color": "purple",
                "imageAlias": "face2",
                "number": 2
              },
              {
                "color": "purple",
                "imageAlias": "face2",
                "number": 2
              },
              {
                "color": "purple",
                "imageAlias": "face2",
                "number": 2
              }
            ],
            [
              {
                "color": "red",
                "imageAlias": "face6",
                "number": 6
              },
              {
                "color": "red",
                "imageAlias": "face6",
                "number": 6
              }
            ]
          ],
          "drawnCard": {
            "color": "purple",
            "imageAlias": "face2",
            "number": 2
          },
          "result": "BUST"
        },
        "content": [
          "If you have 4 or more cards of the same number after drawing, you BUST!",
          "When you bust, you lose ALL your cards and score 0 points for that turn.",
          "Your turn ends immediately and play moves to the next player.",
          "The bust only happens when you draw a card that creates a stack of 4+ - existing stacks are safe!"
        ],
        "example": "You have [2,2,2] and draw another 2. Since you now have 4 cards of the same number, you bust and lose everything!",
        "title": "Busting"
      },
      {
        "cardExample": {
          "action": "END_TURN",
          "stacks": [
            [
              {
                "color": "lightblue",
                "imageAlias": "face1",
                "number": 1
              },
              {
                "color": "lightblue",
                "imageAlias": "face1",
                "number": 1
              }
            ],
            [
              {
                "color": "red",
                "imageAlias": "face6",
                "number": 6
              },
              {
                "color": "red",
                "imageAlias": "face6",
                "number": 6
              },
              {
                "color": "red",
                "imageAlias": "face6",
                "number": 6
              }
            ]
          ],
          "totalPoints": 20
        },
        "content": [
          "You can choose to end your turn at any time by clicking 'End Turn'.",
          "When you end your turn, all your cards are scored and added to your total points.",
          "After scoring, your cards are removed and play moves to the next player.",
          "Timing is everything - end too early and miss points, too late and risk busting!"
        ],
        "example": "You have [1,1] and [6,6,6]. End your turn to score 1+1+6+6+6 = 20 points safely.",
        "title": "Ending Your Turn"
      },
      {
        "cardExample": {
          "finalScores": [
            {
              "player": "Player 1",
              "score": 85
            },
            {
              "player": "Player 2",
              "score": 92,
              "winner": true
            },
            {
              "player": "Player 3",
              "score": 78
            },
            {
              "player": "Player 4",
              "score": 92,
              "winner": true
            }
          ]
        },
        "content": [
          "The game ends when the deck runs out of cards.",
          "All remaining cards in players' hands are automatically scored.",
          "The player with the highest total score wins!",
          "In case of a tie, all tied players are declared winners.",
          "Strategy tip: Balance aggressive play with safe scoring throughout the game!"
        ],
        "example": "Final scores: Player 1: 85, Player 2: 92, Player 3: 78, Player 4: 92. Players 2 and 4 tie for the win!",
        "title": "Winning the Game"
      }
    ],
    "SUBTITLE": "Master the art of risk and reward!",
    "TITLE": "How to Play Pelusas"
  },
  "PLAYER_POSITIONS": [
    "bottom",
    "left",
    "top",
    "right"
  ],
  "PLAYER_SETUP": {
    "2": {
      "names": {
        "bottom": "Player 1",
        "left": "N/A",
        "right": "N/A",
        "top": "Player 2"
      },
      "positions": [
        "bottom",
        "top"
      ]
    },
    "3": {
      "names": {
        "bottom": "Player 1",
        "left": "Player 2",
        "right": "Player 3",
        "top": "N/A"
      },
      "positions": [
        "bottom",
        "left",
        "right"
      ]
    },
    "4": {
      "names": {
        "bottom": "Player 1",
        "left": "Player 2",
        "right": "Player 4",
        "top": "Player 3"
      },
      "positions": [
        "bottom",
        "left",
        "top",
        "right"
      ]
    }
  },
  "TUTORIAL_COLORS": {
    "accent": "from-yellow-400 to-orange-500",
    "cardColors": {
      "darkblue": "bg-blue-800",
      "darkred": "bg-red-800",
      "green": "bg-green-500",
      "lightblue": "bg-sky-400",
      "lightgreen": "bg-lime-400",
      "orange": "bg-orange-500",
      "pink": "bg-pink-400",
      "purple": "bg-purple-500",
      "red": "bg-red-500",
      "yellow": "bg-yellow-400"
    },
    "danger": "from-red-500 to-pink-600",
    "primary": "from-green-900 via-green-800 to-green-700",
    "secondary": "from-yellow-400 to-yellow-500",
    "success": "from-green-500 to-emerald-600"
  },
  "UI_TEXT": {
    "BACK_BUTTON": "Back",
    "CARDS_LABEL": "Cards",
    "CLOSE_BUTTON": "Close",
    "CONTINUE_BUTTON": "Continue",
    "DECK_EMPTY": "Deck is empty!",
    "DRAW_CARD_BUTTON": "Draw Card",
    "END_TURN_BUTTON": "End Turn",
    "FINAL_SCORES_LABEL": "Final Scores",
    "GAME_OVER": "Game Over",
    "MAIN_MENU_BUTTON": "Main Menu",
    "MUSIC_VOLUME_LABEL": "Music Volume",
    "MUTE_AUDIO_LABEL": "Mute All Audio",
    "MUTE_BUTTON": "Mute",
    "PAUSE_TITLE": "Game Paused",
    "PLAYERS_LABEL": "Players",
    "PLAYER_BUSTED": "BUSTED",
    "PLAY_FRIENDS_BUTTON": "Play with Friends",
    "PLAY_VS_CPU_BUTTON": "Play vs. Computer",
    "POINTS_LABEL": "points",
    "RESTART_BUTTON": "Play Again",
    "SELECT_PLAYERS_TITLE": "Select Players",
    "SETTINGS_BUTTON": "Settings",
    "SETTINGS_TITLE": "Settings",
    "SFX_VOLUME_LABEL": "Sound Effects Volume",
    "STEAL_BUTTON": "Steal",
    "STEAL_MESSAGE": "You stole matching stacks!",
    "TIE_LABEL": "Tie",
    "UNMUTE_BUTTON": "Unmute",
    "WINNER_LABEL": "Winner",
    "COLOR_PALETTE_LABEL": "Color Theme",
    "COLOR_PALETTE_DEFAULT": "Emerald Forest"
  }
};
